var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",on:{"click":_vm.resetGame}},[_vm._v("Reset Game")])
}
var staticRenderFns = []

export { render, staticRenderFns }